"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError = void 0;
const config_1 = require("../config");
const logError = (key) => {
    console.error(config_1.TEXTS[key]);
};
exports.logError = logError;
